/**
 * Raiz da aplicação.
 *
 * A surface (clínica ou plataforma) é decidida pela SESSÃO, nunca pela URL —
 * quem impõe isso é `src/router/guardas.ts`, em cada loader. O caminho é
 * conveniência de navegação, não permissão.
 */

import type { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

/**
 * O roteador entra por fora porque criá-lo já dispara o loader da URL atual:
 * quem decide QUANDO isso acontece é o arranque, depois de a sessão estar
 * lida. Ver `criarRoteador` em `src/router/router.tsx`.
 */
export function App({ roteador }: { roteador: ReturnType<typeof createBrowserRouter> }) {
    return <RouterProvider router={roteador} />;
}
